/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(".card").hover(function(){
  $(this).find('.card__info').show();
}, function(){
  $(this).find('.card__info').hide();
});

$('.thumb_image img').click(function(){
  var new_img = $(this).attr('data-src');
  $('.main_image img').attr('src',new_img);
});

$('body').css('padding-top', '80px');